/** Type safe version of Object.entries */
export const objectEntries = (obj) => Object.entries(obj);
